import React, { useEffect, useState } from "react"
import { useAuth } from "../../context/AuthContext"
import { supabase } from "../../lib/supabaseClient"
import { useNavigate } from "react-router-dom"

const AddressPage: React.FC = () => {
  const { profile, refreshProfile } = useAuth()
  const navigate = useNavigate()

  const [address1, setAddress1] = useState("")
  const [address2, setAddress2] = useState("")
  const [zip, setZip] = useState("")
  const [city, setCity] = useState("")
  const [country, setCountry] = useState("Suisse")
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!profile) return
    setAddress1(profile.address_line1 || "")
    setAddress2(profile.address_line2 || "")
    setZip(profile.zip_code || "")
    setCity(profile.city || "")
    setCountry(profile.country || "Suisse")
  }, [profile])

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)

    const { error } = await supabase.from("profiles")
      .update({
        address_line1: address1 || null,
        address_line2: address2 || null,
        zip_code: zip || null,
        city: city || null,
        country: country || "Suisse"
      })
      .eq("id", profile?.id)

    setLoading(false)
    if (error) return alert("Erreur lors de la mise à jour.")

    await refreshProfile()
    navigate("/account")
  }

  return (
    <div className="card" style={{ maxWidth: 600, margin: "2rem auto" }}>
      <h1 className="card-title">Adresse</h1>

      <form onSubmit={handleSave}>
        <label className="label">Adresse</label>
        <input className="input" value={address1} onChange={e => setAddress1(e.target.value)} />

        <label className="label">Complément d’adresse</label>
        <input
          className="input"
          value={address2}
          onChange={e => setAddress2(e.target.value)}
        />

        <label className="label" style={{ marginTop: "1rem" }}>NPA</label>
        <input className="input" value={zip} onChange={e => setZip(e.target.value)} />

        <label className="label" style={{ marginTop: "1rem" }}>Ville</label>
        <input className="input" value={city} onChange={e => setCity(e.target.value)} />

        <label className="label" style={{ marginTop: "1rem" }}>Pays</label>
        <input className="input" value={country} onChange={e => setCountry(e.target.value)} />

        <button className="btn btn-primary" type="submit" style={{ marginTop: "1.5rem" }}>
          {loading ? "Enregistrement…" : "Enregistrer"}
        </button>
      </form>
    </div>
  )
}

export default AddressPage
